/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useQuery } from '@pinia/colada';
import CompensationPlanService from '../services/CompensationPlanService';
import type { CompensationPlan } from '../models/compensationPlanTypes';

export const useCompensationPlanStore = defineStore('compensationPlan', () => {
  const plan = ref<CompensationPlan | null>(null);
  const loading = ref(false);
  const error = ref<unknown>(null);

  const planQuery = useQuery({
    key: () => ['compensation-plan'],
    query: () => CompensationPlanService.fetchPlan(),
    enabled: false,
    staleTime: 0,
  });

  let loadToken = 0;

  async function loadPlan() {
    const token = ++loadToken;
    loading.value = true;
    error.value = null;
    try {
      const state = await planQuery.refetch(true);
      if (token !== loadToken) return;
      plan.value = state.data ?? null;
    } catch (e) {
      if (token !== loadToken) return;
      error.value = e;
      throw e;
    } finally {
      if (token === loadToken) loading.value = false;
    }
  }

  return { plan, loading, error, loadPlan };
});
